import {override} from 'mobx';
import {RedirectModel} from "./redirect-model";

export class FootballRedirectModel extends RedirectModel {
  @override get from() {
    return `${this.languageDisplayName}/football`;
  }

  @override get to() {
    return `${this.languageDisplayName}`;
  }
}
